<template>
  <div class="live-5gLive">
    <div class="tab-con">
      <div class="tab-item" :class="{active: tabActive==='1'}" @click="changeTab('1')">直播<span class="line"></span></div>
      <div class="tab-item" :class="{active: tabActive==='2'}" @click="changeTab('2')">回放<span class="line"></span></div>
      <div class="tab-item" :class="{active: tabActive==='3'}" @click="changeTab('3')">视频<span class="line"></span></div>
      <div class="tab-item" :class="{active: tabActive==='4'}" @click="changeTab('4')">动态<span class="line"></span></div>
    </div>
    <div class="overflow">
      <component :is="thisComponent"></component>
    </div>
  </div>
</template>

<script>
import shopLiveList from './shopLiveList'
import shopLiveReplayList from './shopLiveReplayList'
import shopVideoList from './shopVideoList'
import shopArticle from './shopArticle'
export default {
  components: {
    shopLiveList,
    shopLiveReplayList,
    shopVideoList,
    shopArticle,
  },
  inject: ['reload'], // App.vue中的reload方法
  data() {
    return {
      tabActive: '1',
      thisComponent: '',
    }
  },
  created() {
    if(this.$route.query.tab){
      console.log(this.$route.query.tab)
      this.tabActive = this.$route.query.tab
      if(this.tabActive==='1'){
        this.thisComponent = 'shopLiveList'
      }else if(this.tabActive==='2'){
        this.thisComponent = 'shopLiveReplayList'
      }else if(this.tabActive==='3'){
        this.thisComponent = 'shopVideoList'
      }else if(this.tabActive==='4'){
        this.thisComponent = 'shopArticle'
      }
    }
  },
  methods: {
    changeTab(tab){
      if(this.$route.query.tab===tab){
        return false
      }
      this.$router.push({name: '5gLive', query: {shopId: this.$route.query.shopId, tab}})
      this.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.live-5gLive{
  .tab-con{
    display: flex;height: 44px;
    .tab-item{
      position: relative;font-size: 16px;padding: 0 12px;
      display: flex;justify-content: center;align-items: center;
      .line{
        position: absolute;bottom: 0;left: 20.5px;
        width: 15px;height: 3px;
        border-radius: 1px;
      }
      &.active{
        font-size: 18px;
        .line{background-color: rgba(0,191,32,1);}
      }
    }
  }
  .overflow{
    position: absolute;top: 46px;
    left: 0;right: 0;bottom: 0;
    overflow: auto;
  }
}
</style>